module.exports = __webpack_public_path__ + "assets/img/b161d91087dd2d97fb83e746bdfc4c56.svg";